import Vue from 'vue';
import Vuex from 'vuex';

import box from './modules/box';
import sidebar from './modules/sidebar';
import step from './modules/step';
import option from './modules/option';
import jump from './modules/jump';
import auth from './modules/auth';
import canvas from './modules/canvas';
import modal from './modules/modal';
import code from './modules/code';
import tableData from './modules/report/tableData';
import metrics from './modules/report/metrics';
import quiz from './modules/quiz';
import theme from './modules/theme';
import optionEmails from './modules/report/optionEmails';
import resume from './modules/report/resume';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'staging';

export default new Vuex.Store({
  modules: {
    box,
    sidebar,
    step,
    option,
    jump,
    auth,
    canvas,
    modal,
    code,
    tableData,
    metrics,
    quiz,
    theme,
    optionEmails,
    resume,
  },
  strict: debug,
});



/** WEBPACK FOOTER **
 ** ./src/store/index.js
 **/